import {
  PUSH_PRODUCT_COMPARE,
  POP_PRODUCT_COMPARE,
  SET_COMPARE_DATA,
  CLEAR_COMPARE,
  OPEN_COMPARE,
  TOGGLE_SHOW_DIFFERENCES,
} from '@/context/compare/types';

export const pushProductCompare = payload => ({
  type: PUSH_PRODUCT_COMPARE,
  payload,
});

export const popProductCompare = payload => ({
  type: POP_PRODUCT_COMPARE,
  payload,
});

export const setCompareDate = payload => ({
  type: SET_COMPARE_DATA,
  payload,
});

export const clearCompare = payload => ({
  type: CLEAR_COMPARE,
  payload,
});

export const openCompare = payload => ({
  type: OPEN_COMPARE,
  payload,
});

export const toggleShowDifferences = () => ({
  type: TOGGLE_SHOW_DIFFERENCES,
});
